import React from "react";
import ColoredBorderSummaryCard from "../../../components/cards/ColoredBorderSummaryCard";
import { useAppSelector } from "../../../redux/app/hooks";

const PublicContractSummary = () => {
  const { counts, countsLoading, list } = useAppSelector(
    (state) => state.publicContracts
  );

  const total = counts.ALL ?? list.meta.totalItems ?? 0;
  const pending = counts.PENDING ?? 0;
  const paid = counts.PAID ?? 0;
  const expired = counts.EXPIRED ?? 0;
  const canceled = counts.CANCELED ?? 0;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      <ColoredBorderSummaryCard
        title="Total"
        value={total}
        borderColor="border-t-purple-600"
        loading={countsLoading}
        loadingColor="#9333EA"
      />
      <ColoredBorderSummaryCard
        title="Pending"
        value={pending}
        borderColor="border-t-yellow-500"
        loading={countsLoading}
        loadingColor="#EAB308"
      />
      <ColoredBorderSummaryCard
        title="Paid"
        value={paid}
        borderColor="border-t-blue-500"
        loading={countsLoading}
        loadingColor="#3B82F6"
      />
      <ColoredBorderSummaryCard
        title="Expired"
        value={expired}
        borderColor="border-t-gray-500"
        loading={countsLoading}
        loadingColor="#6B7280"
      />
      <ColoredBorderSummaryCard
        title="Canceled"
        value={canceled}
        borderColor="border-t-red-500"
        loading={countsLoading}
        loadingColor="#EF4444"
      />
    </div>
  );
};

export default PublicContractSummary;
